import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo2 from '../../assets/logos/logo2.png';
import Tik from '../../assets/images/titok.png';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    const handleScroll = () => setScrolled(window.scrollY > 20);

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/about', label: 'Qui sommes-nous' },
    { path: '/Services', label: 'Nos Services' },
    { path: '/Galerie', label: 'Galerie' },
    { path: '/faq', label: 'Faq' },
 
  ];

  const linkVariants = {
    hover: { scale: 1.05, color: '#f8c851', transition: { duration: 0.2 } },
    tap: { scale: 0.95 }
  };

  const menuVariants = {
    open: {
      opacity: 1,
      height: 'auto',
      transition: { staggerChildren: 0.07, delayChildren: 0.2 }
    },
    closed: {
      opacity: 0,
      height: 0,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1,
        when: 'afterChildren'
      }
    }
  };

  const itemVariants = {
    open: { y: 0, opacity: 1, transition: { y: { stiffness: 1000, velocity: -100 } } },
    closed: { y: 20, opacity: 0, transition: { y: { stiffness: 1000 } } }
  };

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 999,
        background: scrolled ? 'rgba(61, 59, 59, 0.82)' : 'transparent',
        transition: 'all 0.4s ease',
        boxShadow: scrolled ? '0 2px 15px rgba(0,0,0,0.1)' : 'none',
      }}
    >
      {/* Top Bar */}
      <div style={{
        background: 'linear-gradient(90deg,rgb(16,16,16) 0%,rgb(7,7,8) 100%)',
        padding: '8px 0',
        color: '#fff',
        fontSize: '0.9rem'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <div style={{fontSize:'11px'}}><i className="fas fa-phone" style={{ color: '#f8c851' }}></i> (+243) 814-213-889 / 971-746-522</div>
              <div style={{fontSize:'11px'}}><i className="fas fa-envelope" style={{ color: '#f8c851' }}></i> infos@gekas-security.com</div>
            
            </div>
           
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div style={{ padding: '10px 0',  background: 'linear-gradient(90deg,rgba(70, 71, 73, 0) 0%,rgba(64, 65, 67, 0.01) 100%)', }}>
        <div className="container" style={{
          maxWidth: '1200px',
          margin: '0 auto',
         
          padding: '0 15px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
          {/* Logo */}
          <Link to="/">
            <motion.img
              src={Logo2}
              alt="Logo Principal"
              style={{ height: '100px' }}
              whileHover={{ rotate: [0, -5, 0] }}
              transition={{ duration: 0.5 }}
            />
          </Link>

          {/* Mobile Toggle */}
          {isMobile && (
            <motion.div
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              whileTap={{ scale: 0.9 }}
              style={{
                cursor: 'pointer',
                display: 'block',
              }}
            >
              <div style={{
                width: '24px',
                height: '24px',
                position: 'relative',
              }}>
                <span style={{
                  position: 'absolute',
                  top: '50%',
                  left: 0,
                  width: '100%',
                  height: '3px',
                  backgroundColor: '#e2e8f0',
                  transform: 'translateY(-50%)',
                }}></span>
                <span style={{
                  position: 'absolute',
                  top: '50%',
                  left: 0,
                  width: '100%',
                  height: '3px',
                  backgroundColor: '#e2e8f0',
                  transform: 'translateY(-50%) rotate(90deg)',
                }}></span>
              </div>
            </motion.div>
          )}

          {/* Nav Links */}
          {!isMobile && (
            <nav style={{
              display: 'flex',
              gap: '25px',
              alignItems: 'center',
            }}>
              {navLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  style={{
                    color: location.pathname === link.path ? '#f8c851' : '#f3f5f8',
                    textDecoration: 'none',
                    fontWeight: 700,
                    fontSize: '1.1rem',
                    position: 'relative',
                    padding: '10px 15px',
                  }}
                >
                  <motion.span
                    variants={linkVariants}
                    whileHover="hover"
                    whileTap="tap"
                  >
                    {link.label}
                  </motion.span>
                  {location.pathname === link.path && (
                    <motion.div
                      initial={{ width: 0 }}
                      animate={{ width: '100%' }}
                      transition={{ duration: 0.3 }}
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        height: '3px',
                        background: '#f8c851',
                        borderRadius: '2px',
                      }}
                    />
                  )}
                </Link>
              ))}
            </nav>
          )}

          {/* Contact Button */}
          <Link to="/contact" style={{
            background: 'linear-gradient(90deg,rgb(213, 103, 13) 0%,rgb(120, 35, 7) 100%)',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '30px',
            textDecoration: 'none',
            fontWeight: 700,
            fontSize: '1rem',
            whiteSpace: 'nowrap',
            boxShadow: '0 4px 10px rgba(10, 25, 47, 0.3)',
          }}>
            <motion.span whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <i className="fas fa-envelope" style={{ marginRight: '8px' }}></i> Contact
            </motion.span>
          </Link>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && isMobile && (
            <motion.div
              initial="closed"
              animate="open"
              exit="closed"
              variants={menuVariants}
              style={{
                width: '100%',
                background: 'rgba(255, 255, 255, 0.98)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
              }}
            >
              <motion.ul style={{ listStyle: 'none', padding: '20px', margin: 0 }}>
                {navLinks.map(link => (
                  <motion.li
                    key={link.path}
                    variants={itemVariants}
                    style={{ marginBottom: '15px' }}
                  >
                    <Link
                      to={link.path}
                      onClick={() => setMobileMenuOpen(false)}
                      style={{
                        color: location.pathname === link.path ? '#f8c851' : '#0a192f',
                        textDecoration: 'none',
                        fontWeight: 600,
                        fontSize: '1rem',
                      }}
                    >
                      {link.label}
                    </Link>
                  </motion.li>
                ))}
              </motion.ul>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default Header;
